import { IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';
import { ReservationTabItem, ReservationTabItemText, ReservationTabsContainer } from './Theme';
import { FontFamilies } from "theme/fontConfig";
const ReservationTabs = ({ tabs, displayTabLabel, onTabsChange, activeTab, onDeleteTab }) => {

  const handleChange = (event, newIndex) => {
    onTabsChange(newIndex);
  };

  const handleDeleteTab = (event, tab, tabIndex) => {
    event.stopPropagation();
    onDeleteTab(tab, tabIndex);
  };


  return (
    <ReservationTabsContainer>
      <Tabs
        value={activeTab}
        onChange={(event, newIndex) => {
          console.log('newIndex :', newIndex);
          if (tabs[newIndex - 1] && !tabs[newIndex - 1].valid) return;
          handleChange(event, newIndex);
        }}
        variant="scrollable"
        scrollButtons={false}
        aria-label="scrollable tabs without arrows"
        sx={{
          bgcolor: '#e7edf9',
          borderRadius: '8px 8px 0 0',
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: '#2555ef',
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.id}
            sx={{
              fontFamily: FontFamilies.General,
              border: 'none',
              minHeight: '48px',
              '&.MuiTab-root': {
                padding: '0 16px',
                // opacity: tabs[index - 1] && !tabs[index - 1].valid ? 0.5 : 1,
                cursor: tabs[index - 1] && !tabs[index - 1].valid ? 'not-allowed' : 'pointer',
              },
              '&.Mui-selected': {
                backgroundColor: '#2555ef',
                border: 'none',
                borderRadius: '8px 8px 0 0',
              },
            }}
            label={
              <ReservationTabItem
                active={activeTab === index}
              >
                <ReservationTabItemText
                  disabled={tabs[index - 1] && !tabs[index - 1].valid}
                >
                  {displayTabLabel(tab, index)}
                </ReservationTabItemText>
                {tabs.length > 1 && (

                  <IconButton
                    onClick={(e) => handleDeleteTab(e, tab, index)}
                    size="small"
                  >
                    <CloseIcon
                      sx={{
                        width: '16px',
                      }}
                    />
                  </IconButton>
                )}
              </ReservationTabItem>
            }
          />
        ))}
      </Tabs>
    </ReservationTabsContainer>
  );
};

export default ReservationTabs;
